import styled from "styled-components";

import { RoundedModalContainer } from "./rounded-modal-container";

/**
 * The redesign's modal: one white surface. The default container paints itself grey, which frames
 * whatever white card a screen puts inside it.
 */
export const WhiteModalContainer = styled(RoundedModalContainer)`
  padding: 24px;
  border-radius: 16px;
  background-color: #ffffff;
`;
